module.exports = __webpack_public_path__ + "img/screen4.66c37ee4.png";